export enum CommunityEnum {
  Community = 'COMMUNITY'
}

export enum CommunityEnumApi {
  community = 'community/'
}
